import { AuthSdkError } from '../lib/auth-sdk-error';

export function createIframe(target: URL) {
  const frame = document.createElement('iframe');
  frame.src = target.toString();
  frame.style.display = 'none';

  document.body.appendChild(frame);
  return () => {
    if (document.body.contains(frame)) {
      frame.parentElement?.removeChild(frame);
    }
  };
}

export type MessageData = {
  state: string;
  code: string;
};
export function addPostMessageListener({ issuer, timeout, state }: { issuer: string; timeout: number; state: string }) {
  let responseHandler: (event: MessageEvent) => void;
  let timeoutId: number;
  return new Promise<MessageData>((resolve, reject) => {
    responseHandler = (event: MessageEvent) => {
      if (event.data.state !== state) return;
      if (event.origin !== issuer) {
        throw new AuthSdkError('Invalid origin');
      }
      resolve(event.data);
    };
    window.addEventListener('message', responseHandler);

    timeoutId = setTimeout(() => {
      reject(new AuthSdkError('Authn flow timed out'));
    }, timeout);
  }).finally(() => {
    clearTimeout(timeoutId);
    window.removeEventListener('message', responseHandler);
  });
}
